import { userStaleDataStore } from "./../Stores/UserStaleDataStore";
import { applyRESTQueries } from "../Helpers";
export class BaseRESTConnection {
    constructor(name, meta) {
        this.name = name;
        this.meta = meta;
    }
    applyQuery(message) {
        return applyRESTQueries(this.name, message, this.meta);
    }
    onStaleData(cb) {
        userStaleDataStore.set(cb, this);
    }
    offStaleData(cb) {
        if (typeof cb !== "undefined") {
            userStaleDataStore.delete(cb, this);
        }
        else {
            userStaleDataStore.deleteConnection(this);
        }
    }
}
//# sourceMappingURL=BaseRESTConnection.js.map